/**
 * This enum represents the possible statuses for the creation of a plan link.
 */ export var PlanLinkCreationStatus = /*#__PURE__*/ function(PlanLinkCreationStatus) {
    // The plan link creation was successful.
    PlanLinkCreationStatus["Success"] = "success";
    // The plan link creation was cancelled.
    PlanLinkCreationStatus["Cancelled"] = "cancelled";
    // The plan link creation failed.
    PlanLinkCreationStatus["Failure"] = "failure";
    // The plan link creation failed because the connected plan backlink update failed.
    PlanLinkCreationStatus["Failure_ConnectedPlanBacklinkUpdateFailed"] = "failure-connected-plan-backlink-update-failed";
    // The plan link creation failed because the source task was not found.
    PlanLinkCreationStatus["Failure_SourceTaskNotFound"] = "failure-source-task-not-found";
    // The plan link creation failed because the source task update failed.
    PlanLinkCreationStatus["Failure_SourceTaskUpdateFailed"] = "failure-source-task-update-failed";
    return PlanLinkCreationStatus;
}({});
/**
 * This enum represents the possible statuses for connecting an existing plan to a task.
 */ export var PlanLinkConnectionStatus = /*#__PURE__*/ function(PlanLinkConnectionStatus) {
    // The existing plan was connected to the task successfully.
    PlanLinkConnectionStatus["Success"] = "connect-existing-plan-success";
    // The existing plan connection was cancelled.
    PlanLinkConnectionStatus["Cancelled"] = "cancelled";
    // The existing plan connection failed.
    PlanLinkConnectionStatus["Failure"] = "connect-existing-plan-failure";
    // The existing plan connection failed because the source task was not found.
    PlanLinkConnectionStatus["Failure_SourceTaskNotFound"] = "connect-existing-plan-failure-source-task-not-found";
    // The existing plan connection failed because the source task update failed.
    PlanLinkConnectionStatus["Failure_SourceTaskUpdateFailed"] = "connect-existing-plan-failure-source-task-update-failed";
    return PlanLinkConnectionStatus;
}({});
/** Possible results for disconnecting a linked plan from a task. */ export var PlanLinkDisconnectionStatus = /*#__PURE__*/ function(PlanLinkDisconnectionStatus) {
    /** The reciprocal PLinks were removed successfully. */ PlanLinkDisconnectionStatus["Success"] = "disconnect-plan-success";
    /** The disconnection was cancelled. */ PlanLinkDisconnectionStatus["Cancelled"] = "cancelled";
    /** The operation failed before either PLink was removed. */ PlanLinkDisconnectionStatus["Failure"] = "disconnect-plan-failure";
    /** The plan backlink was removed, but the source task could not be updated. */ PlanLinkDisconnectionStatus["Failure_SourceTaskUpdateFailed"] = "disconnect-plan-failure-source-task-update-failed";
    /** The target plan could not be updated, so the source task was not changed. */ PlanLinkDisconnectionStatus["Failure_TargetPlanUpdateFailed"] = "disconnect-plan-failure-target-plan-update-failed";
    return PlanLinkDisconnectionStatus;
}({});
/** Shared engagement telemetry component name for Plink entry-point interactions. */ export const PlanLinkTelemetryComponentName = "PlanLink";
